import React, { useState, useEffect } from "react";
import { db, storage, auth } from "../firebaseConfig";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  Timestamp,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "../styles/Form.css";
import "../styles/KazaForm.css";
import { saveAccident } from "./kazaRecords";
import { useParams } from "react-router-dom";

export function KazaDuzenle() { const { id } = useParams(); return <KazaEkle recordId={id} />; }
const KazaEkle = ({ recordId = "" }) => {
  const [plakalar, setPlakalar] = useState([]);
  const [personeller, setPersoneller] = useState([]);
  const [formData, setFormData] = useState({
    tarih: "",
    saat: "",
    plaka: "",
    personel: "",
    aciklama: "",
    kazaBasligi: "",
    olayTuru: "TRAFIK", isKazasi: false, personelId: "", tesis: "", yapilanIs: "", sonuc: "BELIRSIZ", alinanOnlemler: "",
  });
  const [kazaFotograf, setKazaFotograf] = useState([]);
  const [raporDosya, setRaporDosya] = useState(null);
  const [existingPhotos, setExistingPhotos] = useState([]);
  const [existingReport, setExistingReport] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [newAttachments, setNewAttachments] = useState([]);
  const [version, setVersion] = useState(0);
  const [saving, setSaving] = useState(false);
  const [recordLoading, setRecordLoading] = useState(!!recordId);
  const [recordError, setRecordError] = useState("");
  const [fileKey, setFileKey] = useState(0);
  useEffect(() => {
    if (!recordId) return undefined;
    let active = true;
    setRecordLoading(true);
    getDoc(doc(db, "kazalar", recordId)).then((snapshot) => {
      if (!snapshot.exists()) throw new Error("Kaza kaydı bulunamadı.");
      if (!active) return;
      const row = snapshot.data();
      const date = row.tarih?.toDate?.() || (row.tarih ? new Date(row.tarih) : null);
      setFormData((previous) => Object.fromEntries(Object.keys(previous).map((key) => [key, key === "tarih" ? (date && !Number.isNaN(date.getTime()) ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}` : "") : row[key] ?? previous[key]])));
      setExistingPhotos(Array.isArray(row.kazaFotoURL) ? row.kazaFotoURL : []);
      setExistingReport(row.raporURL || ""); setAttachments(row.evraklar || []); setVersion(row.version || 0);
    }).catch((error) => { if (active) setRecordError(error.message); }).finally(() => { if (active) setRecordLoading(false); });
    return () => { active = false; };
  }, [recordId]);

  useEffect(() => {
    const fetchData = async () => {
      const plakaQuery = query(
        collection(db, "plates"),
        where("active", "==", true),
        orderBy("plate")
      );
      const personelQuery = collection(db, "personeller");

      const [plakaSnap, personelSnap] = await Promise.all([
        getDocs(plakaQuery),
        getDocs(personelQuery),
      ]);

      const plakaList = plakaSnap.docs.map((doc) => doc.data().plate).sort();
      const personelList = personelSnap.docs.map((d) => ({ id: d.id, ...d.data() }))
        .sort((a, b) => `${a.ad} ${a.soyad}`.localeCompare(`${b.ad} ${b.soyad}`, "tr"));

      setPlakalar(plakaList);
      setPersoneller(personelList);
    };

    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving || recordLoading || recordError) return;

    const currentUser = auth.currentUser;
    if (!currentUser) {
      alert("Kullanıcı giriş yapmamış!");
      return;
    }

    let kazaFotoURL = [...existingPhotos];
    let raporURL = existingReport;
    const evraklar = [...attachments];
    setSaving(true);

    try {
      // Fotoğraf yükleme
      if (kazaFotograf.length > 0) {
        for (const file of kazaFotograf) {
          const kazaRef = ref(storage, `kazalar/foto/${Date.now()}-${Math.random().toString(36).slice(2)}-${file.name}`);
          await uploadBytes(kazaRef, file);
          const url = await getDownloadURL(kazaRef);
          kazaFotoURL.push(url);
        }
      }

      // Rapor yükleme
      if (raporDosya) {
        const raporRef = ref(storage, `kazalar/rapor/${Date.now()}-${Math.random().toString(36).slice(2)}-${raporDosya.name}`);
        await uploadBytes(raporRef, raporDosya);
        raporURL = await getDownloadURL(raporRef);
      }

      // Tarihi Timestamp'e çevir
      const tarihObj = new Date(formData.tarih);
      const tarihTS = isNaN(tarihObj.getTime()) ? null : Timestamp.fromDate(tarihObj);

      for (const file of newAttachments) {
        const fileRef = ref(storage, `kazalar/evrak/${Date.now()}-${Math.random().toString(36).slice(2)}-${file.name}`);
        await uploadBytes(fileRef, file);
        evraklar.push({ name: file.name, url: await getDownloadURL(fileRef) });
      }
      const saved = await saveAccident({ id: recordId, version, user: currentUser, values: {
        ...formData,
        tarih: tarihTS,
        kazaFotoURL,
        raporURL,
        evraklar,
      } });

      alert(recordId ? "Kaza güncellendi. Değişiklikler işlem geçmişine kaydedildi." : "Kaza kaydı başarıyla eklendi.");
      if (recordId) { setExistingPhotos(kazaFotoURL); setExistingReport(raporURL); setAttachments(evraklar); setVersion(saved.version); setKazaFotograf([]); setRaporDosya(null); setNewAttachments([]); setFileKey((key) => key + 1); return; }

      setFormData({
        tarih: "",
        saat: "",
        plaka: "",
        personel: "",
        aciklama: "",
        kazaBasligi: "",
        olayTuru: "TRAFIK", isKazasi: false, personelId: "", tesis: "", yapilanIs: "", sonuc: "BELIRSIZ", alinanOnlemler: "",
      });
      setKazaFotograf([]);
      setRaporDosya(null);
      setNewAttachments([]); setAttachments([]); setFileKey((key) => key + 1);
    } catch (error) {
      console.error("❌ Kayıt hatası:", error);
      alert(error.message || "Kaza kaydı sırasında hata oluştu.");
    } finally { setSaving(false); }
  };

  return (
    <div className="form-container kaza-entry-form">
      <h2>{recordId ? "Kaza Düzenle" : "Kaza Ekle"}</h2>
      {recordLoading && <p>Kaydı yükleniyor...</p>}{recordError && <p role="alert">{recordError}</p>}
      <form aria-label="Kaza kayıt formu" onSubmit={handleSubmit}>
        <fieldset className="kaza-entry-fields" disabled={saving || recordLoading || !!recordError}>
        <label htmlFor="kaza-olayTuru">Olay Türü:</label>
        <select id="kaza-olayTuru" name="olayTuru" value={formData.olayTuru} onChange={(e) => setFormData((prev) => ({ ...prev, olayTuru: e.target.value, isKazasi: e.target.value === "IS_KAZASI" }))}>
          <option value="TRAFIK">Trafik kazası</option><option value="IS_KAZASI">İş kazası</option><option value="RAMAK_KALA">Ramak kala</option>
        </select>
        {formData.olayTuru === "TRAFIK" && <label className="kaza-entry-check"><input type="checkbox" checked={formData.isKazasi} onChange={(e) => setFormData({ ...formData, isKazasi: e.target.checked })} /> Aynı zamanda iş kazası olarak takip et</label>}
        <label htmlFor="kaza-tarih">Tarih:</label>
        <input
          id="kaza-tarih"
          type="date"
          name="tarih"
          value={formData.tarih}
          onChange={handleChange}
          required
        />

        <label htmlFor="kaza-saat">Saat:</label>
        <input
          id="kaza-saat"
          type="time"
          name="saat"
          value={formData.saat}
          onChange={handleChange}
          required
        />

        <label htmlFor="kaza-plaka">Plaka:</label>
        <input
          id="kaza-plaka"
          list="plaka-list"
          name="plaka"
          value={formData.plaka}
          onChange={handleChange}
          required={formData.olayTuru === "TRAFIK"}
        />
        <datalist id="plaka-list">
          {plakalar.map((p) => (
            <option key={p} value={p} />
          ))}
        </datalist>

        <label htmlFor="kaza-personel">Personel:</label>
        <input
          id="kaza-personel"
          list="personel-list"
          name="personel"
          value={formData.personel}
          onChange={(e) => {
            const matches = personeller.filter((p) => `${p.ad} ${p.soyad}` === e.target.value);
            setFormData({ ...formData, personel: e.target.value, personelId: matches.length === 1 ? matches[0].id : "" });
          }}
          required
        />
        <datalist id="personel-list">
          {personeller.map((p) => (
            <option key={p.id} value={`${p.ad} ${p.soyad}`} />
          ))}
        </datalist>

        {(formData.olayTuru !== "TRAFIK" || formData.isKazasi) && <>
          <label htmlFor="kaza-yapilanIs">Olay Sırasında Yapılan İş:</label><input id="kaza-yapilanIs" name="yapilanIs" value={formData.yapilanIs} onChange={handleChange} />
          <label htmlFor="kaza-sonuc">Olay Sonucu:</label><select id="kaza-sonuc" name="sonuc" value={formData.sonuc} onChange={handleChange}><option value="BELIRSIZ">Henüz belirlenmedi</option><option value="YARALANMA_YOK">Yaralanma yok</option><option value="YARALANMA">Yaralanma</option><option value="AGIR">Ağır yaralanma</option><option value="OLUM">Ölüm</option></select>
          <label htmlFor="kaza-onlemler">Alınan İlk Önlemler:</label><textarea id="kaza-onlemler" name="alinanOnlemler" value={formData.alinanOnlemler} onChange={handleChange} rows="3" />
        </>}

        <label htmlFor="kaza-baslik">Kaza Başlığı:</label>
        <input
          id="kaza-baslik"
          type="text"
          name="kazaBasligi"
          value={formData.kazaBasligi}
          onChange={handleChange}
          required
        />

        <label htmlFor="kaza-aciklama">Açıklama:</label>
        <textarea
          id="kaza-aciklama"
          name="aciklama"
          value={formData.aciklama}
          onChange={handleChange}
          rows="4"
          required
        />

        <label htmlFor="kaza-fotograflar">Kaza Fotoğraf(lar)ı:</label>
        {existingPhotos.map((url, index) => <div key={url}><a href={url} target="_blank" rel="noreferrer">Fotoğraf {index + 1}</a><button type="button" onClick={() => setExistingPhotos((rows) => rows.filter((item) => item !== url))}>Fotoğrafı kaldır</button></div>)}
        <input
          key={`photos-${fileKey}`}
          id="kaza-fotograflar"
          type="file"
          accept="image/*"
          multiple
          onChange={(e) => setKazaFotograf(Array.from(e.target.files))}
        />

        <label htmlFor="kaza-rapor">Kaza Raporu (PDF):</label>
        {existingReport && <div><a href={existingReport} target="_blank" rel="noreferrer">Mevcut raporu aç</a><button type="button" onClick={() => setExistingReport("")}>Raporu kaldır</button></div>}
        <input
          key={`report-${fileKey}`}
          id="kaza-rapor"
          type="file"
          accept=".pdf"
          onChange={(e) => setRaporDosya(e.target.files[0])}
        />

        <label htmlFor="kaza-ek-evrak">Ek evraklar (PDF / fotoğraf):</label>
        {attachments.map((file) => <div key={file.url}><a href={file.url} target="_blank" rel="noreferrer">{file.name}</a><button type="button" onClick={() => setAttachments((rows) => rows.filter((item) => item.url !== file.url))}>Evrakı kaldır</button></div>)}
        <input key={`attachments-${fileKey}`} id="kaza-ek-evrak" type="file" accept="application/pdf,image/*" multiple onChange={(e) => setNewAttachments(Array.from(e.target.files || []))} />
        {recordId && <p>Kaldırılan evraklar kaydettiğinizde güncel kayıttan çıkarılır; önceki bağlantılar işlem geçmişinde korunur.</p>}
        <button type="submit">{saving ? "Kaydediliyor..." : recordId ? "Değişiklikleri Kaydet" : "Kaydet"}</button>
        </fieldset>
      </form>
    </div>
  );
};

export default KazaEkle;
